<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-12">
          <div class="pull-right" style="margin-bottom: 10px;">
            <el-input type="search" clearable class="input-sm" placeholder="Client Name" v-model="clientSearchQuery" aria-controls="datatables" style="width:250px; margin-right: 12px;" />
            <el-input type="search" clearable class="input-sm" placeholder="Purchase Order Number" v-model="poSearchQuery" aria-controls="datatables" style="width:250px; margin-right: 12px;" />
          </div>
        </div>
        <div class="col-sm-12">
          <div v-if="loading" style="text-align: center;">
            <img src="static/img/loading.gif"/>
          </div>
          <el-table class="table-striped wrap-whole-words indexed-table-column-width"
                    v-else
                    :data="queriedData"
                    border
                    :max-height="tableHeight(350)"
                    style="width: 100%">
            <el-table-column
                :width="this.constants.INDEX_COLUMN_WIDTHS.NARROW"
                align="center"
                label="#"
                type="index">
            </el-table-column>
            <el-table-column
                :min-width="135"
                label="Project Name"
                prop="name">
                <template v-slot="props">
                    <span class="invisible">{{ props.row.id }}</span>
                    <a href="#" @click.prevent="handleEdit(props.row.id, props.row.purchaseOrderType)"> {{ props.row.header.job.name }} </a>
                </template>
            </el-table-column>
            <el-table-column
                :min-width="115"
                label="P.O. Number"
                prop="builderOrderNumber">
              <template v-slot="props">
                {{ props.row.header.builderOrderNumber }}
              </template>
            </el-table-column>
            <el-table-column
                :min-width="130"
                label="P.O. Type"
                prop="purchaseOrderType">
              <template v-slot="props">
                {{ props.row.purchaseOrderType }}
              </template>
            </el-table-column>
            <el-table-column
                :min-width="110"
                sortable
                :sort-method="(a, b) => callStringSort(a.props.row.header.builder.name, b.props.row.header.builder.name, 'header.builder.name')"
                label="Client"
                prop="header.builder.name">
              <template v-slot="props">
                {{ props.row.header.builder.name }}
              </template>
            </el-table-column>
            <el-table-column
                :min-width="140"
                label="Address"
                prop="address">
              <template v-slot="props">
                {{ buildAddress(props.row.header.job)}}
              </template>
            </el-table-column>
            <el-table-column
                  :min-width="120"
                  label="Description"
                  prop="description">
                <template v-slot="props">
                  {{ props.row.header.task.name }}
                </template>
            </el-table-column>
            <el-table-column
                :min-width="160"
                label="Date Received"
                sortable
                :sort-method="(a, b) => callDateSort(a, b, 'lastUsedAt')"
                prop="issueDate">
                <!-- // changePO doesnt have issueDate, use ternary to get at it-->
              <template v-slot="props">
                {{ (props.row.header.issueDate ? props.row.header.issueDate : props.row.header.changeOrderIssueDate) | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
                width="110"
                fixed="right"
                label="Actions">
              <template v-slot="props">
                <p-button type="success" size="sm" icon>
                  <i class="fa fa-edit" @click="handleEdit(props.row.id, props.row.purchaseOrderType)" title="View/Edit Purchase Order"></i>
                </p-button>
                <p-button v-if="canEdit" type="danger" size="sm" icon @click="confirmDelete(props.row)" title="Delete Purchase Order">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
          <initialize-sample-data-button @resetSampleData="fetchAllPurchaseOrders"></initialize-sample-data-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import Constants from 'src/utilities/constants'
import {dateSort, getTableHeight, notifyError, notifySuccess, stringSort} from 'src/utilities/utils'
import {mapGetters} from 'vuex'
import Permissions from '@/utilities/permissions'
import {NO_CONTENT} from 'http-status-codes'
import InitializeSampleDataButton from './InitializeSampleDataButton'

export default {
  components: {
    InitializeSampleDataButton
  },
  computed: {
    ...mapGetters({
      tableData: 'supplyPro/search/results'
    }),
    canEdit() {
      return this.$can('edit', Permissions.PROJECTS)
    },
    queriedData() {
      if (!this.clientSearchQuery && !this.poSearchQuery) {
        return this.tableData
      }
      return this.tableData // Needs work. Problems when using both searches at the same time.
        .filter((row) => {
          let isIncluded = false
          if (row.header.builder.name && this.clientSearchQuery) {
            const rowValue = row.header.builder.name.toLowerCase()
            if (rowValue.includes && rowValue.includes(this.clientSearchQuery.toLowerCase())) {
              isIncluded = true
            }
          }
          if (row.header.builderOrderNumber && this.poSearchQuery) {
            const rowValue = row.header.builderOrderNumber.toLowerCase()
            if (rowValue.includes && rowValue.includes(this.poSearchQuery.toLowerCase())) {
              isIncluded = true
            }
          }
          return isIncluded
        })
      }
  },
  data() {
    return {
      constants: Constants,
      toDelete: null,
      toDeleteEndpoint: null,
      clientSearchQuery: '',
      poSearchQuery: '',
      loading: false
    }
  },
  methods: {
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    callStringSort(a, b, prop) {
      return stringSort(a, b, prop)
    },
    callDateSort(a, b, prop) {
      return dateSort(a, b, prop)
    },
    buildAddress(jobAddress) {
      return `${jobAddress.street}, ${jobAddress.city}, ${jobAddress.postalCode}`
    },
    async delete() {
      const response = await this.$store.dispatch('delete', {id: this.toDelete, endpoint: this.toDeleteEndpoint})
      if (NO_CONTENT === response.status) {
        this.$store.commit('supplyPro/search/delete', this.toDelete)
        notifySuccess(this, 'Purchase Order Successfully Deleted')
      } else {
        notifyError(this, 'Error Deleting Purchase Order')
      }
    },
    confirmDelete(purchaseOrder) {
      this.toDelete = purchaseOrder.id
      if (purchaseOrder.purchaseOrderType === this.constants.SUPPLYPRO.PO_TYPES.ORIGINAL) {
        this.toDeleteEndpoint = 'supply-pro-purchase-orders'
      } else {
        this.toDeleteEndpoint = 'supply-pro-change-purchase-orders'
      }
      const payload = {
        message: 'Are you sure you want to delete Purchase Order <strong>' + purchaseOrder.header.builderOrderNumber + '</strong> from client <strong>' + purchaseOrder.header.builder.id + '</strong>? This will not cancel the Purchase Order, but it will premanently remove it from PTRAC.',
        entity: purchaseOrder,
        delete: this.delete,
        showButton: true
      }
      this.$eventHub.$emit('show-modal-1', 'Confirm Delete', payload, '600px')
    },
    handleEdit(purchaseOrderId, purchaseOrderType) {
      if (purchaseOrderType === this.constants.SUPPLYPRO.PO_TYPES.CANCELLATION
            || purchaseOrderType === this.constants.SUPPLYPRO.PO_TYPES.RESCHEDULE
            || purchaseOrderType === this.constants.SUPPLYPRO.PO_TYPES.CHANGE) {
        this.showModifyModal(purchaseOrderId)
      } else {
        this.$router.push({path: `/admin/supply-pro/${purchaseOrderId}`})
      }
    },
    showModifyModal(purchaseOrderId) {
      this.$eventHub.$emit('show-modal-1', 'Change Purchase Order', {purchaseOrderId: purchaseOrderId}, '800px')
    },
    async fetchAllPurchaseOrders() {
      this.loading = true
      await this.$store.dispatch('supplyPro/search/fetchAll')
      this.loading = false
    }
  },
  mounted() {
    this.fetchAllPurchaseOrders()
  }
}
</script>
